import React from "react";
import { Grid, TextField } from "@mui/material";
import { AutocompleteComponent } from "components/Autocomplete/AutocompleteComponent";
import { GlobalBox } from "components/Box/GlobalBox";
import { useForm } from "hooks/useForm";
import { useSelector, useDispatch } from "react-redux";
import { initialValues, requiredValues } from "./inputValues";
import { useTransmitterHook } from "./useTransmitterHook";
import { getInvoicesSeries, clearSeriesList } from "redux/actions/invoices/invoicesCashAction";
import { extractIDs } from "helpers/extractIDs";
import { getLogo, clearLogos } from "redux/actions/brands/brandsAction_V2";
import { transmitterConfig } from "./config"
import { useRuleValidator } from "hooks/useRuleValidator";
import { PERMISSIONS } from "router/permissions";

export const TransmitterInvoice = ({ isSaved = false }) => {
  const { companiesList } = useSelector(({ companies }) => companies);
  const { seriesList } = useSelector(({ cashInvoices }) => cashInvoices);
  const { logos } = useSelector(({brandsReducer}) => brandsReducer)
  const dispatch = useDispatch();
  const hasCashConceptRule = useRuleValidator(PERMISSIONS.INVOICE_CASH_CONCEPT);
  const {
    values,
    onChange,
    setValues,
    validate,
    errors,
    reset,
  } = useForm(initialValues.transmitter, requiredValues.transmitterRequired);
  useTransmitterHook({ values, setValues, isSaved, validate, reset, hasCashConceptRule });

  const { idCompany, rfc, permission, series, permissionsOpt, logo, invoiceConcept } = values;

  const handleCompanies = (e) => {
    setValues(e)
    const stations = e.idCompany?.stations ? e.idCompany?.stations : []
    if(idCompany?.id !== e?.idCompany?.id) {
      dispatch(clearLogos())
      dispatch(clearSeriesList())
      setValues({
        series: null,
        logo: null,
        permission: null 
      })
    }
    dispatch(getInvoicesSeries(extractIDs(e.idCompany?.stations)))
    if(stations?.length > 0){
      stations.map( station =>  dispatch(getLogo(station?.id)))
    }
  }
  return (
    <Grid item xs={12} md={6}>
      <GlobalBox
        title={transmitterConfig.title}
        head
        style={{ boxShadow: "none", margin: 0 }}
        styleBody={{ paddingLeft: 0, paddingRight: 0 }}
      >
        <AutocompleteComponent
          label={transmitterConfig.fields.idCompany.label}
          options={companiesList}
          name={transmitterConfig.fields.idCompany.name}
          value={idCompany}
          handleValues={handleCompanies}
          textFieldProps={{
            error: errors.idCompany,
            helperText: errors.idCompany
          }}
        />
        <TextField
          variant="outlined"
          label={transmitterConfig.fields.rfc.label}
          name={transmitterConfig.fields.rfc.name}
          value={rfc}
          onChange={onChange}
          fullWidth
          error={errors.rfc}
          helperText={errors.rfc}
        />
        <AutocompleteComponent
          label={transmitterConfig.fields.permission.label}
          options={permissionsOpt}
          name={transmitterConfig.fields.permission.name}
          value={permission}
          handleValues={setValues}
          textFieldProps={{
            error: errors.permission,
            helperText: errors.permission
          }}
        />
        <AutocompleteComponent
          label={transmitterConfig.fields.series.label}
          options={seriesList}
          name={transmitterConfig.fields.series.name}
          value={series}
          handleValues={setValues}
          textFieldProps={{
            error: errors.series,
            helperText: errors.series
          }}
        />
        <AutocompleteComponent
          label={transmitterConfig.fields.logo.label}
          options={logos}
          name={transmitterConfig.fields.logo.name}
          value={logo}
          handleValues={setValues}
          textFieldProps={{
            error: errors.logo,
            helperText: errors.logo
          }}
        />
        {hasCashConceptRule && (
          <TextField
            variant="outlined"
            label={transmitterConfig.fields.invoiceConcept.label}
            name={transmitterConfig.fields.invoiceConcept.name}
            value={invoiceConcept}
            onChange={onChange}
            fullWidth
            multiline
            minRows={3}
          />
        )}
      </GlobalBox>
    </Grid>
  );
};
